import { PlanType } from '@/enums';
import { useTranslation } from 'react-i18next';

export const DomesticPABenefits_MY = () => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'pa',
  });

  return {
    title: t('title'),
    coverages: {
      parentCoverage: {
        label: t('description'),
        insuredAmountData: [
          {
            classId: 1,
            amount: '',
            remark: null,
            colspan: 3,
          },
        ],
      },
      childrenCoverage: [
        {
          label: t('adult'),
          plan: PlanType.Individual,
          insuredAmountData: [
            {
              classId: 1,
              amount: 'RM50,000',
              remark: null,
              colspan: 3,
            },
          ],
        },
        {
          label: t('children'),
          plan: PlanType.Family,
          insuredAmountData: [
            {
              classId: 1,
              amount: 'RM10,000',
              remark: null,
              colspan: 3,
            },
          ],
        },
        {
          label: t('senior'),
          plan: PlanType.Senior,
          insuredAmountData: [
            {
              classId: 1,
              amount: 'RM50,000',
              remark: null,
              colspan: 3,
            },
          ],
        },
      ],
      insuredAmountRemarks: [
        {
          classId: 1,
          amount: null,
          remark: t('maximum', { amount: 'RM150,000' }),
          colspan: 3,
        },
      ],
    },
  };
};

export default DomesticPABenefits_MY;
